import { Component } from '@theme/component';

// Shared by duplicate badges and section replacements for this document only.
const pageCounts = new Map();
const hour = 60 * 60 * 1000;
const randomInteger = (min, max) => min + Math.floor(Math.random() * (max - min + 1));

/** @extends {Component<{ count: HTMLElement }>} */
class ProductVisitCount extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.renderCount();
  }

  updatedCallback() {
    super.updatedCallback();
    this.renderCount();
  }

  renderCount() {
    const raw = this.dataset.initialCount;
    const parsed = raw === '' || raw == null ? NaN : Number(raw);
    const initial = Number.isSafeInteger(parsed) && parsed >= 0 ? parsed : null;
    let count = initial;

    if (this.dataset.designMode !== 'true' && this.dataset.shop && this.dataset.productId) {
      const key = `net:product-visit-count:v1:${this.dataset.shop}:${this.dataset.productId}`;
      if (!pageCounts.has(key)) {
        try {
          const now = Date.now();
          let saved = null;
          try {
            saved = JSON.parse(localStorage.getItem(key) || 'null');
          } catch (error) {
            // Malformed JSON can be replaced; inaccessible storage cannot.
            if (!(error instanceof SyntaxError)) throw error;
          }
          const valid = saved && Number.isSafeInteger(saved.count) && saved.count >= 0 &&
            Number.isSafeInteger(saved.lastVisitedAt) && saved.lastVisitedAt >= 0 && saved.lastVisitedAt <= now;
          count = valid ? saved.count : (initial ?? randomInteger(20, 100));
          if (valid && now - saved.lastVisitedAt >= hour) {
            count = Math.min(Number.MAX_SAFE_INTEGER, count + randomInteger(1, 3));
          }
          localStorage.setItem(key, JSON.stringify({ count, lastVisitedAt: now }));
          pageCounts.set(key, count);
        } catch {
          // Do not show an invented fallback if persistence is unavailable.
          pageCounts.set(key, initial);
        }
      }
      count = pageCounts.get(key);
    }

    if (this.refs.count) {
      const text = count == null ? '' : String(count);
      if (this.refs.count.textContent !== text) this.refs.count.textContent = text;
    }
    this.hidden = count == null || (count === 0 && this.dataset.hideWhenEmpty === 'true');
  }
}

if (!customElements.get('product-visit-count')) {
  customElements.define('product-visit-count', ProductVisitCount);
}
